import deleteIcon from "assets/images/icons/delete.svg";
import { setPromoCode } from "features/common/layouts/cartSlice";
import { getOnlyTLD, postFetcher } from "helpers/helper";
import { formatIDR } from "helpers/utils";
import { useState, useCallback } from "react";
import { Modal } from "react-bootstrap";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { notifyWarning, notifyError, notifyPromise } from "components/ToastMessage";
// import style from "../../assets/scss/ModalPromoCode.module.scss"; // Removed SCSS import
import Spinner from "react-bootstrap/Spinner";

const ModalPromoCode = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const {
    productsList: cartItems,
    existingDomain,
    orderProcessName,
  } = useSelector((state) => state.cart);
  const { promoCode } = useSelector((state) => state.cart);
  const [promo, setPromo] = useState("");

  const inputCodeHandler = (e) => {
    setPromo(e.target.value);
  };

  const setPromoHandler = (e, code) => {
    e.preventDefault();
    setPromo(code);
  };

  const checkPromoCode = useCallback(async () => {
    try {
      if (cartItems.length === 0) {
        throw new Error("Tidak ada produk di dalam keranjang!");
      }

      let finalBillingCycle;
      const getItem = cartItems?.find((item) => item.pid);
      const getDomain = cartItems?.find((item) => item.domain);
      const prodBillingCycle = getItem?.billingcycle;
      const productPid = getItem?.pid ?? "";
      const domainName = getDomain?.name ?? existingDomain?.domain;
      const domainDuration = getDomain?.duration ?? 1;

      finalBillingCycle =
        prodBillingCycle === "semiannually"
          ? prodBillingCycle.replace("annually", "-annually")
          : prodBillingCycle;

      const payload = {
        promo_code: promo ? promo : promoCode.queryCode,
        pid: productPid,
        extensions: getOnlyTLD(domainName),
        cycles: finalBillingCycle ?? "",
        periods: `${domainDuration}Years` || "",
        productname: "",
      };

      // console.log('Payload yang dikirim:', payload);
      const promoStatus = await postFetcher(process.env.REACT_APP_BASE_API + "order-api/api/v1/promotion/check", payload);
      console.log('Respons dari server:', promoStatus);

      const { code, error, data: details } = promoStatus;

      if (code !== 200) {
        // Handle nested error messages
        let errorMessage = "";
        
        if (error.message?.maxuses) {
          errorMessage = Array.isArray(error.message.maxuses) 
            ? error.message.maxuses[0] 
            : error.message.maxuses;
        } else if (error.message?.cycles) {
          errorMessage = Array.isArray(error.message.cycles) 
            ? error.message.cycles[0] 
            : error.message.cycles;
        } else if (error.message?.periods) {
          errorMessage = Array.isArray(error.message.periods) 
            ? error.message.periods[0] 
            : error.message.periods;
        } else if (error.message?.product) {
          errorMessage = Array.isArray(error.message.product) 
            ? error.message.product[0] 
            : error.message.product;
        } else if (error.message?.domain) {
          errorMessage = Array.isArray(error.message.domain) 
            ? error.message.domain[0] 
            : error.message.domain;
        } else if (error.message?.date) {
          errorMessage = Array.isArray(error.message.date) 
            ? error.message.date[0] 
            : error.message.date;
        } else if (error.message?.onceperclient) {
          errorMessage = Array.isArray(error.message.onceperclient) 
            ? error.message.onceperclient[0] 
            : error.message.onceperclient;
        } else if (typeof error.message === 'string') {
          errorMessage = error.message;
        } else {
          errorMessage = "Promo code tidak valid";
        }
        
        throw new Error(errorMessage);
      }

      return details;
    } catch (error) {
      console.warn(error.message);
      throw error;
    }
  }, [cartItems, promo, promoCode, existingDomain]);

  const usePromoCode = (e) => {
    e.target.disabled = true;
    if (promo === "CYBERMOVE20" && orderProcessName !== "migrasiHosting") {
      notifyError("Maaf, Promo berlaku hanya untuk Migrasi Hosting ");
      e.target.disabled = false;
      return;
    }

    const invalidDomain = cartItems.some((item) => {
      if (item.domain) {
          const tld = item.domain.split(".");
        const tldString = tld.length > 2 ? "." + tld[1] + "." + tld[2] : "." + tld[1];
        const domainName = tld[0];
        const result = tldString === ".web.id" && domainName.length === 2
        return result;
      }
      return false;
    });

    if (invalidDomain && (promo === "SEDEKAHID" || promo === "DOMAINBERKAH")) {
      notifyWarning("Tidak dapat menggunakan kode voucher ini untuk domain premium");
      return;
    }

    notifyPromise(checkPromoCode, {
      pending: "Checking promo code.",
      success: (data) => {
            e.target.disabled = false;
            dispatch(setPromoCode({ productsList: cartItems, promo, data }));
            setTimeout(() => {
              props.modalHandler(false);
            }, 1500);
            return data.message;
          },
      error: (data) => {
            e.target.disabled = false;
            return `${data}`;
      }
    });
  };

  useEffect(() => {
    if (location.pathname === "/paymentmethod" && promoCode.queryCode && props.show) {
      setPromo(promoCode.queryCode);
      notifyPromise(checkPromoCode, {
        pending: "Checking promo code.",
        success: (data) => {
              dispatch(setPromoCode({ promo: promoCode.queryCode, data }));
              setTimeout(() => {
                props.modalHandler(false);
              }, 1500);
              return data.message;
        }
      });
    }
  }, [checkPromoCode, dispatch, location.pathname, promoCode.queryCode, props, props.show]);

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      backdrop="static"
      size="lg"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="promoModalLabel">Pakai Promo</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="input-group position-relative">
          <input
            type="text"
            className={`form-control ${
              promo?.length > 2 ? "border border-danger" : ""
            }`}
            placeholder="Kode Voucher"
            id="voucherInput"
            aria-label="Kode Voucher"
            aria-describedby="btn-usePromo"
            value={promo}
            onChange={inputCodeHandler}
          />
          <button
            className="btn btn-cta fw-normal px-lg-5 px-1"
            type="button"
            id="btn-usePromo"
            disabled={promo?.length > 2 ? false : true}
            style={{ borderRadius: "0 .5em .5em 0" }}
            onClick={usePromoCode}
          >
            Gunakan
          </button>
          {promo.length > 2 && (
            <button
              className="btn btn-link clear-icon"
              onClick={() => setPromo("")}
            >
              <img src={deleteIcon} alt="delete.svg" />
            </button>
          )}
        </div>
        <div className="divider"></div>
        {promoCode.status === "loading" && (
          <div className="promo-wrapper mt-3">
            <h6 className="fw-bold mb-3">Promo yang bisa dipakai</h6>
            <Spinner animation="border" size="sm" />
          </div>
        )}
        {promoCode.status === "fulfilled" && (
          <>
            {promoCode.myVoucher === "Anda Belum Login" && (
              <div
                className="promo-wrapper mt-3"
                style={{ overflow: "auto", maxHeight: "430px" }}
              >
                <h6 className="fw-bold mb-3">Promo yang bisa dipakai</h6>
                <div className="card mb-3 rounded-4 shadow-sm">
                  <h5 className="mb-2 fw-bold text-center text-qw-primary py-5">
                    {promoCode.myVoucher}
                  </h5>
                </div>
              </div>
            )}
            {(promoCode.myVoucher !== "Anda Belum Login" && Array.isArray(promoCode.myVoucher) && promoCode.myVoucher.length === 0) ||
             (promoCode.myVoucher !== "Anda Belum Login" && !promoCode.myVoucher) ? (
              <div className="promo-wrapper mt-3">
                <h6 className="fw-bold mb-3">Promo yang bisa dipakai</h6>
                <h5 className="mb-2 fw-bold text-center text-qw-primary py-5">
                  Anda tidak memiliki promo atau promo Anda sudah kadaluarsa
                </h5>
              </div>
            ) : null}
            {promoCode.myVoucher !== "Anda Belum Login" && Array.isArray(promoCode.myVoucher) && promoCode.myVoucher.length > 0 && (
              <div
                className="promo-wrapper mt-3"
                style={{ overflow: "auto", maxHeight: "430px" }}
              >
                <h6 className="fw-bold mb-3">Promo yang bisa dipakai</h6>
                {promoCode.myVoucher.map((voucher, index) => (
                  <div key={voucher.code || index} className={`card mb-3 rounded-4 shadow-sm ${!voucher.isAvailable ? 'opacity-75' : ''}`}>
                    <div className="card-body p-3">
                      <div className="d-flex justify-content-between align-items-start mb-2">
                      <h6
                          className="mb-0 fw-bold text-qw-primary text-white py-1 px-1"
                        style={{
                          backgroundColor: "#ee4d30",
                          width: "fit-content",
                          borderRadius: "5px",
                        }}
                      >
                          {voucher.type === "Percentage" ? `${parseInt(voucher.value)}%` : formatIDR(voucher.value)}
                      </h6>
                        {voucher.source === 'hosting_voucher' && (
                          <span className="badge bg-info text-dark">Voucher Hosting</span>
                        )}
                      </div>
                      <h5 className="mb-3 fw-bold">{voucher.name}</h5>
                      
                      {/* Tampilkan info limit */}
                      {voucher.limitInfo && (
                        <div className={`small mb-2 ${voucher.isAvailable ? 'text-success' : 'text-danger'}`}>
                          <i className={`bi ${voucher.isAvailable ? 'bi-check-circle' : 'bi-x-circle'}`}></i>
                          {voucher.limitInfo}
                        </div>
                      )}
                      
                      {voucher.snk ? (
                        <p className="mb-2">
                          <span
                            dangerouslySetInnerHTML={{
                              __html: voucher.snk.split("\n").join("<br>"),
                            }}
                          ></span>
                        </p>
                      ) : null}
                      <div className="text-qw-primary fw-bold">
                        Berlaku hingga {voucher.expirationdate}
                      </div>
                      <div className="mb-3 mt-5">
                        <button
                          className={`btn rounded-5 px-4 py-1 ${voucher.isAvailable ? 'btn-cta' : 'btn-secondary'}`}
                          onClick={(e) => setPromoHandler(e, voucher.code)}
                          disabled={!voucher.isAvailable}
                          title={!voucher.isAvailable ? 'Voucher sudah mencapai batas penggunaan' : ''}
                        >
                          {voucher.isAvailable ? 'Pakai promo' : 'Tidak tersedia'}
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ModalPromoCode;
